import {BARRIER_FREE} from "../../components/constants.js";
import { memo } from 'react';
import { useTranslation } from "react-i18next";
import {useSharedLang} from '../../hooks/useSharedLang.js'

const MapControlBarrierFree = memo((props) => {
  const {selectedGroupList,toggleGroupControl} = props;
  const { sharedLang } = useSharedLang();
  const { t } = useTranslation();

  // 現在のバリアフリーの設定
  const getGroupList = () => {
    return [BARRIER_FREE.ELEVATOR , BARRIER_FREE.TOILET ,  BARRIER_FREE.SLOPE];
  }
  const getGroupImg = (code) => {
    var suffix = "";
    if(!isActive(code)){
      suffix = "_grayout";
    }

    switch(code){
      case 'elevator':
        return "/assets/images/mapIcons/elevator" + suffix + ".svg";
      case 'toilet':
        return "/assets/images/mapIcons/toilet" + suffix + ".svg";
      case 'slope':
        return "/assets/images/mapIcons/slope" + suffix + ".svg";
    }
  }

  const onClick = (item) => {
    let code = item.code;
    let newSelectedList = [...selectedGroupList];

    //現在選択されているカテゴリの場合
    if(isActive(code)){
      //リストから選択カテゴリのコードを除外。除外したリストを取得
      newSelectedList = selectedGroupList.filter((val) => val !== code);
    }else{
      //選択カテゴリのコードをリストに追加
      newSelectedList.push(code);
    }
    //バリアフリーのカテゴリ選択コントローラの表示変更→ 再描写
    toggleGroupControl(newSelectedList);
  }

  const isActive = (code) => {
    return selectedGroupList.includes(code);
  }

  return (
    <div className="barrier-control leaflet-bottom leaflet-right">
    {
      getGroupList().slice().reverse().map((row, index) => {
        var className = "leaflet-control leaflet-bar " + row.code + " " + sharedLang;
        
        return <div className={className} key={row.code}>
          <button onClick={() => onClick(row)}>
          <img alt="Search" src={getGroupImg(row.code)}/>
          </button>
        </div>
      })
    }
    </div>
  )
});
  
export default MapControlBarrierFree